<!-- aurora-avatar's built-in tooltip is plain text; ours keeps the clickable mailto link. -->
<aurora-avatar [user]="auroraUser"
               [size]="size"
               [color]="auroraColor"
               [showTooltip]="false"
               [ngbTooltipSticky]="userInfo"
               [disableTooltip]="!model"
               [placement]="['bottom','auto']"></aurora-avatar>
<ng-template #userInfo>
    <div class="user_info">
        <h2 class="user_info--name">{{model?.Name}}<i *ngIf="model?.Disabled" class="text-muted"> (disabled)</i></h2>
        <div class="user_info--title">{{model?.Title}}</div>
        <div class="user_info--email"><a class="on_dark" href="mailto:{{model?.Email}}">{{model?.Email}}</a></div>
    </div>
</ng-template>
